<template>
  <el-input-number v-bind="$attrs" />
</template>
<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "form-number",
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    return {
      props
    };
  }
});
</script>
